var $c5247287ce725677$exports = {};
$c5247287ce725677$exports = {
    "loading": `\u{3A6}\u{3CC}\u{3C1}\u{3C4}\u{3C9}\u{3C3}\u{3B7}...`,
    "placeholder": `\u{395}\u{3C0}\u{3B9}\u{3BB}\u{3BF}\u{3B3}\u{3AE}\u{2026}`
};


export {$c5247287ce725677$exports as default};
//# sourceMappingURL=el-GR.module.js.map
